import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import COLORS from "../../../assets/Colors";
import styled from "styled-components";
import theme from "../../../assets/theme";
import { useState } from "react";
import ActionBar from "../../common/ActionBar";
import Live from "./component/Live";
import Registration from "./NewHost/Registration";
import Atendees from "./NewHost/Atendees";
import QnA from "./component/QandA";
import Upload from "./component/Upload";
import RegistrationDetails from "./NewHost/RegistrationDetails";
import AteendesDetails from "./NewHost/AtendeesDetails";
import { useLocation } from "@reach/router";
import UploadDocument from "./component/UploadDocument";
import useLoader from "../../../hooks/useLoader";
import HostService from "../../../services/HostService";
import useUser from "../../../hooks/useUser";
import useDialog from "../../../hooks/useDialog";
import moment from "moment";
import LivePolls from "./component/LivePolls";
import PushPollResults from "./component/PushPollResult";
import { getErrorMessage } from "../../../helpers/functions";
import { useSnackbar } from "notistack";
import { PrimaryCTAButton } from "../../common/Buttons";

/*
import HostActions from "./component/HostActions";
import Reports from "./component/Reports";
*/

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <StyledText style={{ height: "100%" }}>{children}</StyledText>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StyledText = styled.article`
  font-family: ${theme.fonts.primaryFontBold};
  color: ${COLORS.COLOR_DARK};
  overflow: auto;
`;

const useStyles = makeStyles((themes) => ({
  root: {
    margin: 15,
    [themes.breakpoints.up(640)]: {
      margin: "20px 46px",
    },
    "& .MuiTab-root": {
      padding: "5px 0",
      [themes.breakpoints.up(640)]: {
        padding: "6px 12px",
      },
    },
    "& .MuiTab-wrapper": {
      fontSize: 12,
      [themes.breakpoints.up(640)]: {
        fontSize: 16,
      },
    },
  },

  appBar: {
    color: COLORS.LIGHT_BLUE_LABEL,
    boxShadow: "none",
    background: "transparent",
    fontFamily: theme.fonts.primaryFontBold,
    "& .MuiTabs-flexContainer": {
      justifyContent: "space-between",
      [themes.breakpoints.up(640)]: {
        justifyContent: "flex-start",
      },
    },
  },

  label: {
    display: "flex",
    fontFamily: theme.fonts.primaryFontSemiBold,
    justifyContent: "center",
    alignItems: "center",
    width: 80,
    fontSize: "14px",
    [themes.breakpoints.up(400)]: {
      width: "auto",
      maxWidth: 230,
    },
  },

  hiddenTabs: {
    display: "none",
  },
}));

const TabIndex = () => {
  const classes = useStyles();
  const [value, setValue] = useState();
  const location = useLocation();
  const filterOption = location?.state?.filterOption;
  const eventId = location?.state?.eventId;
  const [modal, setModal] = useState({ state: false });
  const { setLoader } = useLoader();
  const [live, setLive] = useState();
  const { userObject } = useUser();
  const {
    registrationDetails,
    setRegistrationDetails,
    attendees,
    setAttendees,
    trigger,
    setTrigger,
    setRegistrationAtttendees,
    reportAttendees,
    setReportAttendees,
    reportRegistered,
    setReportRegistered,
  } = useDialog();
  const [triggerCall, setTriggerCall] = useState(false);
  const [poll, setPoll] = useState();
  const [triggerPoll, setTriggerPoll] = useState(trigger);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (location.state.apiCall === "past" && location.state.spotRegistration) {
      setValue(2);
    } else if (
      location.state.apiCall === "past" &&
      !location.state.spotRegistration
    ) {
      setValue(1);
    } else {
      setValue(0);
    }
    // setValue(location.state.apiCall === "past" ? 1 : 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatedTime = (time) => {
    // Format the date with AM/PM in the specified format

    time = moment(time, "HH:mm:ss");

    const formattedTimeUppercase = moment(`${time}`).format("hh:mm A");
    // Custom format for output
    const formattedOutput = `${formattedTimeUppercase}`;
    return formattedOutput;
  };

  const actions_input = [
    {
      icon: require("../../../assets/images/Asset 7.svg"),
      dateAndTime: live?.eventDate,
    },
    {
      icon: require("../../../assets/images/Asset 8.svg"),
      dateAndTime: formatedTime(live?.eventTime),
    },
  ];

  useEffect(() => {
    async function hostLiveEvents(hostId, eventId) {
      try {
        setLoader({ state: true, message: "Fetching details..." });
        const response = await HostService.hostLiveEvents(hostId, eventId);
        setLive(response);
      } catch (error) {
        // const message = getErrorMessage(error);
        // enqueueSnackbar(message, {
        //   variant: "error",
        // });
      } finally {
        setLoader({ state: false });
        setTriggerCall(false);
        window.scrollTo(0, 0);
      }
    }
    if (userObject || triggerCall) {
      hostLiveEvents(userObject?.hostId, eventId);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userObject, triggerCall]);

  useEffect(() => {
    async function getPollingResults(eventId) {
      try {
        setLoader({ state: true, message: "Fetching poll results..." });
        const response = await HostService.getPollingResults(eventId);
        setPoll(response);
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
        setTriggerPoll(false);
        window.scrollTo(0, 0);
      }
    }
    if (triggerPoll) {
      getPollingResults(eventId);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerPoll]);

  const downloadPollResults = async () => {
    try {
      setLoader({ state: true, message: "downloding polling result" });
      const pollData = await HostService.getPollingResultsPercentage(eventId);
      if (!pollData.numberOfPollResponses) {
        console.warn("No poll data to download");
        return;
      }
      let newArr = [];
      const resultIndi = pollData.IndividualPollResultsPercentage;
      for (let i = 0; i < resultIndi.length; i++) {
        const item = resultIndi[i];
        const { question, numberOfResponseForQuestion, optionPercentages } =
          item;
        if (optionPercentages && typeof optionPercentages === "object") {
          for (let option in optionPercentages) {
            newArr.push({
              question,
              overallResponseCountForQuestion: numberOfResponseForQuestion,
              optionName: option,
              optionPercentage: optionPercentages[option],
            });
          }
        } else {
          // fallback in case of empty or malformed options
          newArr.push({
            question,
            overallResponseCountForQuestion: numberOfResponseForQuestion,
            optionName: "",
            optionPercentage: "",
          });
        }
      }
      const response = await HostService.downloadAttendeeDetailsNew(eventId, {
        attendeesDetail: newArr,
      });
      if (response) {
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `PollResults-EventId-${eventId}-${new Date().toLocaleDateString(
          "en-GB",
        )}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (err) {
      console.error("Failed to download poll results:", err);
    } finally {
      setLoader({ state: false });
    }
  };

  return (
    <div className="eventsTab">
      <ActionBar breadcrumbs={[live?.eventName]} {...{ actions_input }} />
      <div className={classes.root}>
        <AppBar className={classes.appBar} position="static">
          <Tabs
            value={value}
            indicatorColor="primary"
            onChange={(_, newValue) => setValue(newValue)}
          >
            <Tab
              className={
                location.state.apiCall === "past" ? classes.hiddenTabs : ""
              }
              label={<div className={classes.label}>{"Live"}</div>}
              {...a11yProps(0)}
            />
            <Tab
              className={
                location?.state?.spotRegistration ? classes.hiddenTabs : ""
              }
              label={<div className={classes.label}>{"Registration"}</div>}
              {...a11yProps(1)}
            />
            <Tab
              label={
                <div className={classes.label}>
                  {location?.state?.apiCall === "past"
                    ? "Attendance"
                    : "Attendees"}
                </div>
              }
              {...a11yProps(2)}
            />
            <Tab
              label={<div className={classes.label}>{"QnA"}</div>}
              {...a11yProps(3)}
            />
            {/* <Tab
              disabled={true}
              label={<div className={classes.label}>{"Reports"}</div>}
              {...a11yProps(4)}
            /> */}
            <Tab
              label={<div className={classes.label}>{"Polls"}</div>}
              {...a11yProps(4)}
            />
            <Tab
              label={
                <div className={classes.label}>
                  {"Upload"}{" "}
                  {location.state.upcoming && (
                    <ActionButton
                      className={classes.label}
                      onClick={() => setModal({ state: true })}
                    >
                      <Icon
                        src={require("../../../assets/images/Host Asset 1.svg")}
                      />
                    </ActionButton>
                  )}
                </div>
              }
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              {...a11yProps(5)}
            />
          </Tabs>
        </AppBar>

        <TabPanel value={value} index={0}>
          {" "}
          <Live url={live?.liveStreamSettings} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          {filterOption !== "upcoming" && (
            <Registration
              {...{ setRegistrationDetails, registrationDetails }}
            />
          )}
          <RegistrationDetails
            {...{ setRegistrationDetails, registrationDetails }}
            eventId={eventId}
            hostId={userObject?.hostId}
            orgId={userObject?.orgId}
            hostName={userObject?.firstName + userObject?.lastName}
            eventName={live?.eventName}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Atendees
            eventId={eventId}
            hostId={userObject?.hostId}
            {...{
              filterOption,
              attendees,
              setAttendees,
              registrationDetails,
              setRegistrationDetails,
              reportAttendees,
              setReportAttendees,
              reportRegistered,
              setReportRegistered,
            }}
          />
          <AteendesDetails
            eventId={eventId}
            hostId={userObject?.hostId}
            {...{ setAttendees, setRegistrationAtttendees }}
          />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <QnA
            {...{ setRegistrationDetails }}
            eventId={eventId}
            hostId={userObject?.hostId}
            orgId={userObject?.orgId}
          />{" "}
        </TabPanel>
        {/* <TabPanel value={value} index={4}>
          <Reports />
        </TabPanel> */}
        <TabPanel value={value} index={4}>
          <Container>
            <PrimaryCTAButton
              style={{
                width: "auto",
              }}
              onClick={downloadPollResults}
            >
              Download Poll Results
            </PrimaryCTAButton>
          </Container>
          <LivePolls
            pollQuestions={live?.pollQuestions}
            eventId={eventId}
            {...{ setTriggerCall }}
          />
          <PushPollResults
            IndividualPollResponses={poll?.IndividualPollResponses}
            eventId={eventId}
            {...{ setTriggerPoll, poll }}
          />
        </TabPanel>
        <TabPanel value={value} index={5}>
          <Upload {...{ location, trigger, setTrigger }} />
        </TabPanel>
      </div>
      <UploadDocument {...{ modal, setModal, location, setTrigger }} />
    </div>
  );
};

export default TabIndex;

export const Icon = styled.img``;

const ActionButton = styled.button`
  border: none;
  background: none;
  outline: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 12px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media ${theme?.breakpoints?.sm_up} {
    padding: 20px 0px;
  }
`;
